import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Analyzer from "../pages/analyzer/page";
import Learning from "../pages/learning/page";
import ParentInfo from "../pages/parent-info/page";
import Disclaimer from "../pages/disclaimer/page";
import Checkout from "../pages/checkout/page";
import Signup from "../pages/signup/page";
import Dashboard from "../pages/dashboard/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/analyzer",
    element: <Analyzer />,
  },
  {
    path: "/learning",
    element: <Learning />,
  },
  {
    path: "/parent-info",
    element: <ParentInfo />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
